import React from 'react';
import GenericPullAndPushToolView from '../GenericPullAndPushToolView';
import SemgrepConfigListing from './SemgrepConfigListing';
import SemgrepCredentialsForm from './SemgrepCredentialsForm';

const SemgrepPullAndPushView = (props) => (
    <GenericPullAndPushToolView 
        {...props}
        PullCredentialForm={SemgrepCredentialsForm}
        PullConfigListingView={SemgrepConfigListing}
     />
);

export default SemgrepPullAndPushView;
